// IBAN / BIC checks for the SEPA payment option, shared by the checkout form
// (immediate feedback) and /api/checkout/create-contract (authoritative).

export function normalizeIban(value: string): string {
  return value.replace(/\s+/g, '').toUpperCase();
}

// ISO 13616: country code + 2 check digits + up to 30 alphanumerics, and the
// mod-97 checksum over the rearranged number must be 1.
export function isValidIban(value: string): boolean {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let remainder = 0;
  for (const ch of rearranged) {
    const digits = /\d/.test(ch) ? ch : String(ch.charCodeAt(0) - 55);
    for (const d of digits) remainder = (remainder * 10 + Number(d)) % 97;
  }
  return remainder === 1;
}

export function normalizeBic(value: string): string {
  return value.replace(/\s+/g, '').toUpperCase();
}

// ISO 9362: 4 bank + 2 country + 2 location (+ 3 branch) characters.
export function isValidBic(value: string): boolean {
  return /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(normalizeBic(value));
}
